const initialProps = {
  ticketThree: {
    id: "0",
    totalTicket: 0,
    cliente: "",
  },
};

export default function (state = initialProps, action) {
  switch (action.type) {
    case "CREATE_TICKET_THREE":
      return {
        ...state,
        ticketThree: action.payload,
      };
    case "UPDATE_TICKET_THREE":
      return {
        ...state,
        ticketThree: action.payload,
      };
    default:
      return state;
  }
}
